import { type IIconsVector } from 'shared/ui'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IContactDetails, type IInboxDetails } from 'entities/Analytics/api/types'
import { type CreditUsage } from '../CreditUsage'

export class RowCreditUsage extends RowBase<CreditUsage> {
  constructor(origin: CreditUsage) {
    super(origin)

    makeObservableRowBase(this)
  }

  get direction() {
    if (this.origin.object_event_type === 'call_forwarded') {
      return 'forwarded'
    }

    if (this.origin.title === 'Transcript') {
      return this.origin.details?.direction?.toLowerCase()
    }

    if (!this.origin.title?.split(' ')?.[1]) {
      return 'Unknown'
    }

    return this.origin.title.split(' ')[1].toLowerCase()
  }

  get disabled() {
    return this.origin.details?.from?.is_archived || this.origin.details?.to?.is_archived
  }

  get contact(): IContactDetails | undefined {
    if (this.origin.details?.from?.type === 'contact') {
      return this.origin.details?.from
    }
    if (this.origin.details?.to?.type === 'contact') {
      return this.origin.details?.to
    }
  }
  get inbox(): IInboxDetails | undefined {
    if (this.origin.details?.from?.type === 'inbox') {
      return this.origin.details?.from
    }
    if (this.origin.details?.to?.type === 'inbox') {
      return this.origin.details?.to
    }
  }

  get openContactsDetailsData() {
    if (!this.contact) return null
    return {
      messageId: this.origin.details?.message?.id,
      contactId: this.contact.contact_id,
      inboxId: this.inbox?.inbox_id,
      numberId: this.inbox?.number_id,
    }
  }

  get directionIcon(): IIconsVector {
    return this.direction === 'forwarded'
      ? 'arrowRight'
      : this.direction === 'inbound'
      ? 'arrowLeftDown'
      : 'arrowRightUp'
  }
}
